module.exports = __webpack_public_path__ + "img/elix.ffaef907.svg";